module.exports = __webpack_public_path__ + "img/EventWinPage1114.aba92933.png";